import { StateInterface } from 'client/Interfaces/StateInterface'

import { ProductActions } from '../actions/actionTypes'
import { ProductInterface } from '../Interfaces/ProductInterface'
import { Immutable } from '../Other/Immutable'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = []
type PayloadType = ProductInterface[] | ProductInterface | number | number[]

function assignProducts(state: ProductInterface[], payload: ProductInterface[]) {
  return Immutable.copy(payload)
}

function addProduct(state: ProductInterface[], payload: ProductInterface) {
  const newState = Immutable.copy(state)
  newState.push(payload)
  return newState
}

function updateProduct(state: ProductInterface[], product: ProductInterface) {
  const newState = Immutable.copy(state)
  newState[newState.findIndex((p) => p?.id === product?.id)] = product
  return newState
}

function updateProducts(state: ProductInterface[], payload: ProductInterface[]) {
  const newState = Immutable.copy(state)
  payload.forEach((editedProduct) => (newState[newState.findIndex((p) => p?.id === editedProduct?.id)] = editedProduct))
  return newState
}

function deleteProduct(state: ProductInterface[], payload: number) {
  return Immutable.copy(state).filter((p) => p?.id !== payload)
}

function deleteProducts(state: ProductInterface[], payload: number[]) {
  return Immutable.copy(state).filter((p) => !payload.includes(p.id))
}

const reducer = ReducerBuilder.create<ProductInterface[], PayloadType>(INITIAL_STATE)
  .mapAction(ProductActions.LOAD_PRODUCTS, assignProducts)
  .mapAction(ProductActions.CREATE_PRODUCT, addProduct)
  .mapAction(ProductActions.UPDATE_PRODUCT, updateProduct)
  .mapAction(ProductActions.UPDATE_PRODUCTS, updateProducts)
  .mapAction(ProductActions.DELETE_PRODUCT, deleteProduct)
  .mapAction(ProductActions.DELETE_PRODUCTS, deleteProducts)
  .build()

export default reducer

// selectors
export const productsSelector = (state: StateInterface): ProductInterface[] => state.products
